export default {
  carta: "LETTER",
  yourLastOrders: "YOUR LAST ORDERS",
  productOrderNotAvailable:
    "Sorry, the product you are ordering is not available.",
  noOrders: "You have no orders yet",
  updated: "Updated!",
  updatingzClosuresSummaryCollection:
    "Updating zClosures summary collection ...",
  updateOrdersAndPaymentSummariesCollection:
    "Updating orders and payment summaries collection ...",
  whatDishesAre: "What dishes are",
  theMaximumNumberOfProductAllowed:
    "The maximum number of products allowed is 20",
  orderPlaced: "Order placed",
  updatePaymentsCollection: "Updating payments collection ..."
};
